import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { PageLayoutStandard, SiteFooterLayout } from '@shapeable/ui';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`
    .shp--link-page-banner__title {
      font-weight: 500;
      font-family: ${theme.FONT('heading')};
      line-height: 1;
    }

    .shp--link-page-banner__subtitle {
      line-height: 1.4;
    }
      
    .shp--link-page-banner__subtitle {
      margin-top: ${theme.UNIT(3)};
    }

    .shp--link-page-banner__cta-wrapper {
      margin-top: ${theme.UNIT(3)};
    }
  `,
  tablet: css`
    .shp--link-page-banner__title {
      font-size: 3.3em;
    }

    .shp--link-page-banner__subtitle {
      line-height: 1.25;
      font-size: 1.3em;
      margin-top: ${theme.UNIT(3)};
    }

    .shp--link-page-banner__subtitle {
      margin-top: ${theme.UNIT(4)};
    }

    .shp--link-page-banner__cta-wrapper {
      margin-top: ${theme.UNIT(4)};
    }
  `,
  desktop: css`
    .shp--link-page-banner__title {
      font-size: 5.2em;
    }

    .shp--link-page-banner__subtitle {
      margin-top: ${theme.UNIT(7)};
      font-size: 1.9em;
    }

    .shp--link-page-banner__cta-wrapper {
      margin-top: ${theme.UNIT(7)};
    }
  `
});

const FooterStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
};

export const PageLayoutHome: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  return (
    <My.Layout 
      entity={entity}
      slices={slices}
      headerProps={{ 
        bannerType: 'carousel',
        showSlideControls: true,
        showOverlayGradient: true, 
        backgroundColor: '#000000',
        aspectRatio: { base: 16/9, desktop: 16/9 },
        carouselBannerProps: {
          bannerProps: {
            backgroundImageProps: {
              overlayColor: '#00000033',
            },
          }
        }
       }}
      className={className}
    >
    </My.Layout>
  )
};